module.exports = __webpack_public_path__ + "static/media/arrow.a4cfc45f.png";